'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var toUri = require('multiaddr-to-uri');

var debug = require('debug');

var CID = require('cids');

var shuffle = require('array-shuffle');

var AbortController = require('abort-controller');

var preload = require('./runtime/preload-nodejs');

var log = debug('ipfs:preload');
log.error = debug('ipfs:preload:error');

module.exports = function (options) {
  options = options || {};
  options.enabled = Boolean(options.enabled);
  options.addresses = options.addresses || [];

  if (!options.enabled || !options.addresses.length) {
    log('preload disabled');

    var _api = function _api() {};

    _api.start = function () {};

    _api.stop = function () {};

    return _api;
  }

  var stopped = true;
  var requests = [];
  var apiUris = options.addresses.map(toUri);

  var api = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var fallbackApiUris, success, now, _iterator, _step, _loop, _ret;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!stopped) {
                _context2.next = 3;
                break;
              }

              throw new Error("preload ".concat(path, " but preloader is not started"));

            case 3:
              if (typeof path !== 'string') {
                path = new CID(path).toString();
              }

              fallbackApiUris = shuffle(apiUris);
              success = false;
              now = Date.now();
              _iterator = _createForOfIteratorHelper(fallbackApiUris);
              _context2.prev = 8;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var uri, controller;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        uri = _step.value;

                        if (!stopped) {
                          _context.next = 3;
                          break;
                        }

                        throw new Error("preload aborted for ".concat(path));

                      case 3:
                        controller = void 0;
                        _context.prev = 4;
                        controller = new AbortController();
                        requests = requests.concat(controller);
                        _context.next = 9;
                        return preload("".concat(uri, "/api/v0/refs?r=true&arg=").concat(encodeURIComponent(path)), {
                          signal: controller.signal
                        });

                      case 9:
                        success = true;
                        _context.next = 15;
                        break;

                      case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](4);
                        if (_context.t0.type !== 'aborted') log.error(_context.t0);

                      case 15:
                        _context.prev = 15;
                        requests = requests.filter(function (r) {
                          return r !== controller;
                        });
                        return _context.finish(15);

                      case 18:
                        if (!success) {
                          _context.next = 20;
                          break;
                        }

                        return _context.abrupt("return", "break");

                      case 20:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop, null, [[4, 12, 15, 18]]);
              });

              _iterator.s();

            case 11:
              if ((_step = _iterator.n()).done) {
                _context2.next = 18;
                break;
              }

              return _context2.delegateYield(_loop(), "t0", 13);

            case 13:
              _ret = _context2.t0;

              if (!(_ret === "break")) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("break", 18);

            case 16:
              _context2.next = 11;
              break;

            case 18:
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t1 = _context2["catch"](8);

              _iterator.e(_context2.t1);

            case 23:
              _context2.prev = 23;

              _iterator.f();

              return _context2.finish(23);

            case 26:
              log("".concat(success ? '' : 'un', "successfully preloaded ").concat(path, " in ").concat(Date.now() - now, "ms"));
              _context2.next = 32;
              break;

            case 29:
              _context2.prev = 29;
              _context2.t2 = _context2["catch"](0);
              log.error(_context2.t2);

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, null, [[0, 29], [8, 20, 23, 26]]);
    }));

    return function api(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  api.start = function () {
    stopped = false;
  };

  api.stop = function () {
    stopped = true;
    log("aborting ".concat(requests.length, " pending preload request(s)"));
    requests.forEach(function (r) {
      return r.abort();
    });
    requests = [];
  };

  return api;
};